import { render, staticRenderFns } from "./SearchBoxComponent.vue?vue&type=template&id=699004c2&scoped=true&"
import script from "./SearchBoxComponent.vue?vue&type=script&lang=js&"
export * from "./SearchBoxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699004c2",
  null
  
)

export default component.exports